import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin, ArrowUp, Linkedin } from 'lucide-react';

const ModernFooter = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Redes sociales con sus URLs
  const socialLinks = [
    { Icon: Linkedin, url: 'https://uy.linkedin.com/company/plaza-rural', label: 'LinkedIn' },
    { Icon: Twitter, url: 'https://x.com/plazarural', label: 'X (Twitter)' },
    { Icon: Instagram, url: 'https://www.instagram.com/plazarural', label: 'Instagram' },
    { Icon: Facebook, url: 'https://www.facebook.com/@www.plazarural.com.uy/', label: 'Facebook' },
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-green-900 to-gray-900 text-white relative overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-green-500 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-emerald-500 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <img
                src="/web/logo_blanco.png"
                alt="Plaza Rural"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              La plataforma líder en remates de ganado sudamericano. Conectando ganaderos con compradores desde 2001.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map(({ Icon, url, label }) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-10 h-10 bg-white/10 hover:bg-green-600 rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                >
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              {['Inicio', 'Remates', 'Precios', 'Noticias', 'Contacto'].map((link) => (
                <li key={link}>
                  <a
                    href={`#${link.toLowerCase()}`}
                    className="text-gray-400 hover:text-green-400 transition-colors duration-300 flex items-center group"
                  >
                    <span className="w-0 h-0.5 bg-green-400 group-hover:w-4 transition-all duration-300 mr-2"></span>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">Servicios</h4>
            <ul className="space-y-3">
              {['Remates Online', 'Asesoría', 'Valuaciones', 'Logística', 'Financiamiento'].map((service) => (
                <li key={service}>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-green-400 transition-colors duration-300 flex items-center group"
                  >
                    <span className="w-0 h-0.5 bg-green-400 group-hover:w-4 transition-all duration-300 mr-2"></span>
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-gray-400">
                <Phone className="w-5 h-5 text-green-400 mt-1" />
                <div>
                  <p className="font-semibold text-white">26041258</p>
                  <p className="text-sm">Lunes a Viernes 9-18hs</p>
                </div>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <Mail className="w-5 h-5 text-green-400 mt-1" />
                <div>
                  <p className="font-semibold text-white">info@plazarural.com</p>
                  <p className="text-sm">Respuesta en 24hs</p>
                </div>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <MapPin className="w-5 h-5 text-green-400 mt-1" />
                <div>
                  <p className="font-semibold text-white">Av Juan M Ferrari 1251, Oficina 11</p>
                  <p className="text-sm">Montevideo, Uruguay</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-400 text-sm">
            © 2025 PlazaRural. Todos los derechos reservados.
          </p>
          <div className="flex space-x-6 text-sm">
            <a href="#" className="text-gray-400 hover:text-green-400 transition-colors">
              Términos
            </a>
            <a href="#" className="text-gray-400 hover:text-green-400 transition-colors">
              Privacidad
            </a>
            <a href="#" className="text-gray-400 hover:text-green-400 transition-colors">
              Cookies
            </a>
          </div>
        </div>
      </div>

      {/* Scroll to top button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 bg-gradient-to-r from-green-600 to-green-500 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 z-50 group"
      >
        <ArrowUp className="w-6 h-6 text-white group-hover:-translate-y-1 transition-transform" />
      </button>
    </footer>
  );
};

export default ModernFooter;
